import { ClientCartAddress_Second, type TranslatedValue } from "@swo/storefront";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../../../../../styles/styles-css-variables";
import { SwarovskiButton } from "../../../../../../../components/_shared-components/ui-elements/SwarovskiButton";
import { SwarovskiButtonSpinner } from "../../../../../../../components/_shared-components/ui-elements/SwarovskiButtonSpinner";
import React from "react";
import { T } from "../../../../../../../components/T";

export function AddressActionButtons<Address extends ClientCartAddress_Second>({
  primaryActionStatus,
  primaryAction,
  secondaryAction,
}: {
  primaryAction: {
    callback: (checkoutFormValidData: Address) => Promise<void>;
    label: TranslatedValue;
    className?: string;
  };
  secondaryAction?: {
    callback: () => void;
    label: TranslatedValue;
  };
  primaryActionStatus: "pending" | "disabled" | "normal";
}) {
  return (
    <div
      css={css`
        display: flex;
        // to swap focus order
        flex-direction: row-reverse;

        justify-content: flex-start;
        align-items: stretch;

        gap: 20px;

        color: ${CSS_COLORS.Green};
      `}
    >
      <span
        css={css`
          display: flex;
          align-items: stretch;

          position: relative;
          width: 100%;

          > * {
            width: 100%;
          }
        `}
      >
        <SwarovskiButton
          type={"submit"}
          variant={"green"}
          as={"button"}
          size={"small"}
          disabled={primaryActionStatus === "disabled"}
          className={primaryAction.className}
        >
          <SwarovskiButtonSpinner isPending={primaryActionStatus === "pending"} />
          <T>{primaryAction.label}</T>
        </SwarovskiButton>
      </span>

      {secondaryAction && (
        <SwarovskiButton
          as={"button"}
          size={"small"}
          type={"button"}
          variant={"ghost-underline"}
          onClick={() => secondaryAction.callback()}
        >
          <T>{secondaryAction.label}</T>
        </SwarovskiButton>
      )}
    </div>
  );
}
